"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bulciago": {
    "5f875fb7": [{
      "hkey": "99161864",
      "slug": "bulciago",
      "name": "Bulciago",
      "primary": true,
      "skipSearch": false
    }],
    "bulciaghetto": [{
      "hkey": "99161864",
      "slug": "bulciago",
      "name": "Bulciago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "74866367": [{
      "hkey": "99161864",
      "slug": "bulciago",
      "name": "Bulciago",
      "primary": true,
      "skipSearch": false
    }],
    "campolasco": [{
      "hkey": "99161864",
      "slug": "bulciago",
      "name": "Bulciago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc5d628f": [{
      "hkey": "99161864",
      "slug": "bulciago",
      "name": "Bulciago",
      "primary": true,
      "skipSearch": false
    }],
    "dosso": [{
      "hkey": "99161864",
      "slug": "bulciago",
      "name": "Bulciago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;